import {
    Page,
    bindableForm,
    RequiredFieldValidator,
    asyncCommand
} from 'react-mvvm';
import queryString from 'query-string';
import { observable } from 'mobx';

import hello from 'hellojs';
import {
    setPasswordByEmail,
    SetPasswordByEmailRequest
} from 'model/Api/Account/SetPasswordByEmailRequest';
import HomePage from 'web/screen/HomePage/HomePage';

class ResetPasswordByEmailPage extends Page {
    @observable.ref setPasswordRequest: SetPasswordByEmailRequest;
    @observable errorMsg: string;
    @observable isLoading: boolean;

    constructor(private parent: HomePage) {
        super();

        this.errorMsg = '';
        this.isLoading = false;

        const query = queryString.parse(globalThis.location.search);

        this.setPasswordRequest = {
            userId: !query.userId
                ? ''
                : Array.isArray(query.userId)
                ? query.userId[0]
                : query.userId,
            token: !query.token
                ? ''
                : Array.isArray(query.token)
                ? query.token[0]
                : query.token,
            password: '',
            confirmPassword: ''
        };
    }

    setPasswordForm = bindableForm<SetPasswordByEmailRequest>()
        .addField('password', { validator: RequiredFieldValidator })
        .addField('confirmPassword', { validator: RequiredFieldValidator })
        .bindTo(() => this.setPasswordRequest);

    onSubmit = asyncCommand(
        async () => {
            this.errorMsg = '';
            if (!(await this.setPasswordForm.validate())) return;
            this.isLoading = true;

            this.setPasswordForm.commit();
            try {
                const token = await setPasswordByEmail(this.setPasswordRequest);
                if ('accessToken' in token) {
                    hello.utils.store('customJWT', {
                        access_token: token.accessToken.token,
                        refresh_token: token.refreshToken.token
                    });
                    window.location.href = '/';
                }
                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                if (
                    e.response.data.errors &&
                    e.response.data.errors.length != 0
                ) {
                    this.errorMsg = e.response.data.errors.join(', ');
                }
            }
        },
        () => this.setPasswordForm.isDirty
    );
}

export default ResetPasswordByEmailPage;
